// extracted by mini-css-extract-plugin
module.exports = {"container":"_2DGUgBtT17TP4t6L9kjRkO","inner":"JHSdzy4OAblfqVBNhK1Gg","icon":"_3nDGb5w8iicX8M8Ufvo6o0"};